import { apiClient } from './apiClient';

export type OutsideProviderType = {
  id: number;
  name: string;
};

export type OutsideProvider = {
  id: number;
  name: string;
  type: {
    id: number;
    name: string;
  };
  contact: {
    contactPerson: string;
    phone: string | null;
    cell: string | null;
    email: string | null;
    ccEmails: string[] | null;
  };
};

export type ValidateOutsideProvidersPayload = {
  clientId: number;
  outsideProviders: {
    outsideProvider: {
      outsideProviderTypeId: number;
      name: string;
      contact: {
        contactPerson: string;
        phone?: string;
        cell?: string;
        email?: string;
        ccEmails?: string[];
      };
    };
    startingDate: string;
    endingDate?: string;
  }[];
};

export async function getOutsideProviderTypes() {
  const response = (await apiClient.get(
    '/clients/outside-provider-types',
    {}
  )) as {
    results: OutsideProviderType[];
  };

  return response.results;
}

export const getOutsideProviders = async () => {
  const response = (await apiClient.get('/clients/outside-providers', {})) as {
    results: OutsideProvider[];
  };

  return response.results;
};

export const getK1Providers = async () => {
  const response = (await apiClient.get('/clients/k1-providers', {})) as {
    results: OutsideProvider[];
  };

  return response.results;
};

export const validateOutsideProviders = (
  clientId: number,
  payload: ValidateOutsideProvidersPayload
): Promise<{ isValid: boolean; validationErrors?: string[] }> => {
  return apiClient.post(
    `clients/${clientId}/validate-outside-providers`,
    payload
  );
};
